export default "__VITE_ASSET__DHBwzAJu__"